module.exports = __webpack_public_path__ + "static/media/Shield.2820ac64.svg";